<template>
  <div class="calico-risk-level">
    <div
      class="label--small"
      :class="colorClass"
    >
      {{ riskLevel }}
    </div>
  </div>
</template>

<script>
import { RiskLevels } from '@/enums'

export default {
  name: 'CalicoRiskLevel',
  props: {
    riskLevel: { 
      type: String, 
      default: ''
    }
  },
  computed: {
    colorClass() {
      switch (this.riskLevel) {
        case RiskLevels.LOW: return 'risk-low'
        case RiskLevels.MEDIUM_LOW: return 'risk-medium-low'
        case RiskLevels.MEDIUM: return 'risk-medium'
        case RiskLevels.MEDIUM_HIGH: return 'risk-medium-high'
        case RiskLevels.HIGH: return 'risk-high'
        case RiskLevels.UNAVAILABLE: return 'risk-unavailable'
        default: return 'risk-unavailable'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.calico-risk-level {
  .risk-low         { color: $color-green; }
  .risk-medium-low  { color: $color-cyan; }
  .risk-medium      { color: $color-yellow; }
  .risk-medium-high { color: $color-orange-light; }
  .risk-high        { color: $color-pink; }
  .risk-unavailable { color: $color-neutral-light; }
}
</style>
